var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inspired-by"},[_vm._v(" Inspired by... "),_c('div',{staticClass:"inspired-by__name"},[_vm._t("name",function(){return [_vm._v("Name")]}),_c('span',{staticClass:"inspired-by__amount"},[_c('playbooks-svg-increase'),_vm._t("increase",function(){return [_vm._v("100")]}),_vm._v("%")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }